export default __webpack_public_path__ + "static/media/museum.d2ab0171.svg";